import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {AccountsComponent} from "./accounts.component";
import {DataEntryAccountsComponent} from "./data-entry.accounts.component";
import {UnderwriterAccountsComponent} from "./underwriter.accounts.component";
import {FundingSpecialistWithDebtAccountsComponent} from "./funding-specialist.with-debt.accounts.component";
import {FundingSpecialistWithoutDebtAccountsComponent} from "./funding-specialist.without-debt.accounts.component";

import {DataTableModule} from "../../components/common/datatables/datatable.module";
import {PipesModule} from "../../pipes/pipes.module";
import {ClientStatusModule} from "../client-status/client-status.module";
import {ClientsService} from "../../models/clients/clients.service";

@NgModule({
    declarations: [
        AccountsComponent,
        DataEntryAccountsComponent,
        UnderwriterAccountsComponent,
        FundingSpecialistWithDebtAccountsComponent,
        FundingSpecialistWithoutDebtAccountsComponent
    ],
    imports: [
        CommonModule,
        DataTableModule,
        PipesModule,
        ClientStatusModule,
    ],
    exports: [
        AccountsComponent,
        DataEntryAccountsComponent,
        UnderwriterAccountsComponent,
        FundingSpecialistWithDebtAccountsComponent,
        FundingSpecialistWithoutDebtAccountsComponent
    ],
    providers: [
        ClientsService,
    ]
})

export class AccountsModule {
}




// WEBPACK FOOTER //
// ./src/app/modules/accounts/accounts.module.ts